export default __webpack_public_path__ + "static/imago-logo-full-9cd01d9d2f90cdafb6282d58473b53b4.svg";